import i18next from "i18next";

import { AcceptedValueTypeModel, AcceptedModelType } from './ValueTypes';

const t = i18next.t.bind(i18next);

const NESTED_VALUE_SEPARATOR = '; ';
const ID_FIELD = 'id';

function formatValue(modelDescription, fieldName, value) {
    const fieldDescription = modelDescription[fieldName];

    //an array of records would spill its own commas into the row:
    //collapse it into the single cell the user sees
    if (fieldDescription instanceof AcceptedValueTypeModel &&
        fieldDescription.acceptedModelType === AcceptedModelType.Table &&
        Array.isArray(value)) {
        const labelField = fieldDescription.modelDescription.searchBarField;
        return value.map(record => record[labelField]).join(NESTED_VALUE_SEPARATOR);
    }

    //every other number in a row is a 0/1 flag, except the primary key:
    //without this the ingredient with id 1 exports its id as "Sí"
    if (fieldName === ID_FIELD) return value;
    if (value === 1) return t('literals::Yes');

    return value;
}

/**
 * Download a set of records as a CSV file, one column per field of the first record.
 * @param {Array} records rows as returned by the api
 * @param {Object} modelDescription the crudConfig modelDescription these records belong to
 * @param {String} fileName name of the downloaded file, extension included
 */
export function downloadRecordsAsCSV(records, modelDescription, fileName) {
    const replacer = (key, value) => {
        if (!value) return '';  // specify how you want to handle null values here
        return value;
    }

    const header = Object.keys(records[0]);
    const translatedHeader = header.map(fieldName => t('model::fields::' + fieldName));

    const csv = [
        translatedHeader.join(','), // header row first
        ...records.map(row => header.map(fieldName =>
            JSON.stringify(formatValue(modelDescription, fieldName, row[fieldName]), replacer)).join(','))
    ].map(row => {
        return row.replace(/(?:\\[rnt])+/g, ' ')
    }).join('\r\n')

    const data = new Blob(["\uFEFF" + csv], { type: 'text/csv; charset=utf-8' });
    const csvURL = window.URL.createObjectURL(data);
    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', fileName);
    tempLink.click();
}
